<template>
       <div class="rightCol">
          <div class="tastingNav">
            <h4>
              <font style="vertical-align: inherit;">
                <font style="vertical-align: inherit;">{{title}}</font>
              </font>
               <font style="vertical-align: inherit;">
                <font style="vertical-align: inherit;"></font>
              </font>
              <span></span>
            </h4>
            <ul class="mainParent">
              <li v-for="(item,index) in contents" :key='index' class="cat-item"  @click='menuActive(item)' :class="{'current-cat':item.active}">
                <a>
                  <font style="vertical-align: inherit;">
                    <font style="vertical-align: inherit;">{{item.name}}</font>
                  </font>
                </a>

                <ul class="firstLevel" :style="{display:item.active?'block':'none'}">
                  <li v-for="(it,inde) in item.child" :key='inde' @click.stop="activestop(it,item)">

                    <a class="trigger" style="cursor:pointer">{{it.name||it}}</a>

                    <ul  v-if="it.child&&it.child.length" :style="{display:it.active?'block':'none'}">

                      <li v-for="(ind,x) in it.child" :key='x' @click.stop="activestop(ind)">
                        <a
                         style="cursor:pointer"
                        >{{ind.title}}</a>
                      </li>

                    </ul>

                  </li>

                </ul>
              </li>


            </ul>
          </div>
        </div>
</template>

<script>
import ajax from '../ajax'
export default {
    data() {
        return {
            contents:[]
        }
    },
    props:{
      menudata:{
        default:{}
      },
      title:{
        default:''
      }
    },
    created() {

    },
    watch: {
      menudata(value){
        this.getdata()
      }
    },
    methods: {
        activestop(data,parent){
          if(data.child&&data.child.length){
            data.active = !data.active
          }

          this.$emit('OnClick',data,parent)
        },
        menuActive(data){
            data.active = !data.active
        },
        operData(name,data){
          let ar = {
            name,
            child:[],
            active:false
          };
          if(data instanceof Array){
            ar.child = data
          }else if(typeof data == 'string'){
            delete  ar.child
          }else{
          for(let item in data){
                ar.child.push(this.operData(item,data[item]))
              }
          }
          return ar
        },
        getdata(){
            let data = []
            for(let item in this.menudata){
              data.push(this.operData(item,this.menudata[item]))
            }
            this.contents = data
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/template/rightMenu.vue